import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import MiniCalendar from './MiniCalendar';

// Левая колонка: создание события, мини-календарь и списки календарей с фильтром.
const CalendarSidebar = ({
  groups, visibleCalendars, onToggleCalendar, selectedDate, onSelectDate, events, locale,
  onAddEvent, onAddCalendar,
}) => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState({});

  const toggleGroup = (groupId) =>
    setCollapsed((prev) => ({ ...prev, [groupId]: !prev[groupId] }));

  return (
    <aside className="cal-sidebar">
      <button type="button" className="cal-primary-btn" onClick={onAddEvent}>
        <Icon name="plus" size={16} />
        {t('calendar.newEvent')}
      </button>

      <MiniCalendar value={selectedDate} events={events} locale={locale} onSelect={onSelectDate} />

      <div className="cal-groups">
        {groups.map((group) => {
          const open = !collapsed[group.id];
          return (
            <div className="cal-group" key={group.id}>
              <button type="button" className="cal-group-head" onClick={() => toggleGroup(group.id)}>
                <span>{group.label}</span>
                <Icon name={open ? 'chevron-down' : 'chevron-right'} size={16} />
              </button>

              {open && (
                <ul className="cal-group-list">
                  {group.calendars.map((calendar) => {
                    const checked = visibleCalendars.includes(calendar.id);
                    return (
                      <li key={calendar.id}>
                        <button
                          type="button"
                          className="cal-calendar-row"
                          onClick={() => onToggleCalendar(calendar.id)}
                        >
                          <span
                            className={`cal-checkbox${checked ? ' checked' : ''}`}
                            style={checked ? { background: calendar.color, borderColor: calendar.color } : undefined}
                          >
                            {checked && <Icon name="check" size={11} />}
                          </span>
                          <span className="cal-calendar-name">{calendar.name}</span>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </div>

      <button type="button" className="cal-secondary-btn" onClick={onAddCalendar}>
        <Icon name="plus" size={16} />
        {t('calendar.newCalendar')}
      </button>
    </aside>
  );
};

export default CalendarSidebar;
